import lightGallery from "lightgallery";
// Plugins
import lgThumbnail from "lightgallery/plugins/thumbnail";

document.addEventListener("DOMContentLoaded", function() {
    window.launchGallery = function(e) {
        const reference = references.find(ref => ref.id == e.id);
        let imgs = [];

        console.log(e);
        imgs.push({
            src: reference.cover_details.list.original,
            thumb: reference.cover_details.list.size400x400
        });

        reference.article.gallery_details.forEach(function(media) {
            imgs.push({
                src: media.list.original,
                thumb: media.list.size400x400
            });
        });

        let dynamicGallery = lightGallery(e, {
            plugins: [lgThumbnail],
            licenseKey: "A6D0EDC7-AFC045A3-8B6D8519-53558262",
            download: false,
            dynamic: true,
            showCloseIcon: true,
            dynamicEl: imgs,
            thumbnail: true,
            toggleThumb: true,
            allowMediaOverlap: true,
            mobileSettings: { showCloseIcon: true }
        });

        dynamicGallery.openGallery();
    };
});
